import React from "react";
import {useFormContext} from "react-hook-form";
import {CheckboxField} from "src/packages/react-hook-form-mui";

export default function FormCheckboxField({name, ...props}) {
  const {control, formState: {errors, isSubmitting}} = useFormContext();

  return (
    <CheckboxField
      name={name}
      control={control}
      errors={errors}
      disabled={isSubmitting}
      {...props}
    />
  );
}
